<template>
  <v-container fluid>

    <v-row dense align="center" justify="space-between" no-gutters>
      <v-col cols="12" md="2" sm="12" xs="12">
        <label class="menunamestyle ml-10">{{this.$session.get("MENUNAME")}}</label>
      </v-col>
      <v-spacer/>
      <template v-if="grade >= 50">
      <v-col  cols="12" md="3" sm="12" xs="12">
        <comdialog :comname="SEARCH_COM_NAME" @cancelcallback="comsearchclear" @callback="comsearchcb"></comdialog>
      </v-col>
      </template>
      <v-col  cols="12" md="3" sm="12" xs="12">
        <eventdialog :eventname="SEARCH_EVENT_NAME" :comidx="SEARCH_COM_IDX" @callback="eventsearchcb"></eventdialog>
      </v-col>
    </v-row>

    <v-row align="center" dense>
      <v-spacer/>
      <v-col cols="12" md="2" sm="12" xs="12">
        <v-menu
          v-model="date1"
          :close-on-content-click="false"
          :nudge-right="40"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
          >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="search_start_date"
              :label="$t('common_search_start')"
              prepend-icon="event"
              readonly outlined dense hide-details
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker v-model="search_start_date" @input="date1 = false" :first-day-of-week="0" :locale="$i18n.locale"></v-date-picker>
        </v-menu>      
      </v-col>
      <v-col cols="12" md="2" sm="12" xs="12">                      
        <v-menu
          v-model="date2"
          :close-on-content-click="false"
          :nudge-right="40"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
          >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="search_end_date"
              :label="$t('common_search_end')"
              prepend-icon="event"
              readonly outlined dense hide-details
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker v-model="search_end_date" @input="date2=false" :first-day-of-week="0" :locale="$i18n.locale"></v-date-picker>
        </v-menu>                    
      </v-col>
      <v-col cols="12" md="1" sm="6" xs="6" class="d-flex justify-center">
        <v-checkbox v-model="checkdate" dense :label="$t('chartuserinfo_label1')" />
      </v-col>
      <v-col cols="12" md="2" sm="6" xs="6" class="d-flex justify-center">
        <v-btn class="search_btn" elevation="0" outlined large @click="search_run">{{$t("common_ok")}}</v-btn>
        <v-btn class="ml-2" color="#4e6ef7"  rounded large @click="startDownload()"><v-icon color="white">cloud_download</v-icon></v-btn>
      </v-col>
    </v-row>

    <v-row dense justify="center">
      <v-col cols="4" md="1" sm="4" xs="4" style="padding:2px">
        <div class="chartsum_round">
          <label class="chartsum_title">{{$t('chartuserinfo_col1')}}</label>
          <label class="chartsum_value"  style="font-size:20px">{{ totalsum }}</label>
        </div>
      </v-col>
      <v-col cols="4" md="1" sm="4" xs="4" style="padding:2px">
        <div class="chartsum_round">
        <label class="chartsum_title">{{$t('chartuserinfo_col2')}}</label>
        <label class="chartsum_value" style="font-size:20px">{{ msum+" ("+(msum/totalsum*100).toFixed(1)+"%)"}}</label>
        </div>
      </v-col>
      <v-col cols="4" md="1" sm="4" xs="4" style="padding:2px">
        <div class="chartsum_round">
        <label class="chartsum_title">{{$t('chartuserinfo_col3')}}</label>
        <label class="chartsum_value" style="font-size:20px">{{ gsum+" ("+(gsum/totalsum*100).toFixed(1)+"%)"}}</label>
        </div>
      </v-col>
      <v-col cols="4" md="1" sm="4" xs="4" style="padding:2px">
        <div class="chartsum_round">
        <label class="chartsum_title">{{$t('chartuserinfo_col4')}}</label>
        <label class="chartsum_value" style="font-size:20px">{{ age10sum+" ("+(age10sum/totalsum*100).toFixed(1)+"%)"}}</label>
        </div>
      </v-col>
      <v-col cols="4" md="1" sm="4" xs="4" style="padding:2px">
        <div class="chartsum_round">
        <label class="chartsum_title">{{$t('chartuserinfo_col5')}}</label>
        <label class="chartsum_value" style="font-size:20px">{{ age20sum+" ("+(age20sum/totalsum*100).toFixed(1)+"%)"}}</label>
        </div>
      </v-col>
      <v-col cols="4" md="1" sm="4" xs="4" style="padding:2px">
        <div class="chartsum_round">
        <label class="chartsum_title">{{$t('chartuserinfo_col6')}}</label>
        <label class="chartsum_value" style="font-size:20px">{{ age30sum+" ("+(age30sum/totalsum*100).toFixed(1)+"%)"}}</label>
        </div>
      </v-col>
      <v-col cols="4" md="1" sm="4" xs="4" style="padding:2px">
        <div class="chartsum_round">
        <label class="chartsum_title">{{$t('chartuserinfo_col7')}}</label>
        <label class="chartsum_value" style="font-size:20px">{{ age40sum+" ("+(age40sum/totalsum*100).toFixed(1)+"%)"}}</label>
        </div>
      </v-col>
      <v-col cols="4" md="1" sm="4" xs="4" style="padding:2px">
        <div class="chartsum_round">
        <label class="chartsum_title">{{$t('chartuserinfo_col8')}}</label>
        <label class="chartsum_value" style="font-size:20px">{{ age50sum+" ("+(age50sum/totalsum*100).toFixed(1)+"%)"}}</label>
        </div>
      </v-col>
      <v-col cols="4" md="1" sm="4" xs="4" style="padding:2px">
        <div class="chartsum_round">
        <label class="chartsum_title">{{$t('chartuserinfo_col9')}}</label>
        <label class="chartsum_value" style="font-size:20px">{{ age60sum+" ("+(age60sum/totalsum*100).toFixed(1)+"%)"}}</label>
        </div>
      </v-col>
      <v-col cols="4" md="1" sm="4" xs="4" style="padding:2px">
        <div class="chartsum_round">
        <label class="chartsum_title">{{$t('chartuserinfo_col10')}}</label>
        <label class="chartsum_value" style="font-size:20px">{{ age70sum+" ("+(age70sum/totalsum*100).toFixed(1)+"%)"}}</label>
        </div>
      </v-col>
      <v-col cols="4" md="1" sm="4" xs="4" style="padding:2px">
        <div class="chartsum_round">
        <label class="chartsum_title">{{$t('chartuserinfo_col11')}}</label>
        <label class="chartsum_value" style="font-size:20px">{{ age80sum+" ("+(age80sum/totalsum*100).toFixed(1)+"%)"}}</label>
        </div>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" md="6" sm="6" xs="6">
        <canvas ref="drawarea1" style="width:95%"/>
      </v-col>
      <v-col cols="12" md="6" sm="6" xs="6">
        <canvas ref="drawarea2" style="width:95%"/>
      </v-col>
    </v-row>

    <v-row class="mt-5">
      <v-col>
        <v-simple-table 
          height="40vh"
          dense fixed-header
          class="datatablestyle"
          >
          <template v-slot:default>
            <thead style="height:48px">
              <tr>
                <th class="text-center header_text_style">{{$t('chartuserinfo_col12')}}</th>
                <th class="text-center header_text_style">{{$t('chartuserinfo_col1')}}</th>
                <th class="text-center header_text_style">{{$t('chartuserinfo_col2')}}</th>
                <th class="text-center header_text_style">{{$t('chartuserinfo_col3')}}</th>
                <th class="text-center header_text_style">{{$t('chartuserinfo_col4')}}</th>
                <th class="text-center header_text_style">{{$t('chartuserinfo_col5')}}</th>
                <th class="text-center header_text_style">{{$t('chartuserinfo_col6')}}</th>
                <th class="text-center header_text_style">{{$t('chartuserinfo_col7')}}</th>
                <th class="text-center header_text_style">{{$t('chartuserinfo_col8')}}</th>
                <th class="text-center header_text_style">{{$t('chartuserinfo_col9')}}</th>
                <th class="text-center header_text_style">{{$t('chartuserinfo_col10')}}</th>
                <th class="text-center header_text_style">{{$t('chartuserinfo_col11')}}</th>
              </tr>
            </thead>
            <tbody>
              <tr style="background-color:#f0f0f0">
                <td class="text-center">{{$t('chartuserinfo_label2')}}</td>
                <td class="text-center">{{ totalsum }}</td>
                <td class="text-center">{{ msum+" ("+(msum/totalsum*100).toFixed(1)+"%)"}}</td>
                <td class="text-center">{{ gsum+" ("+(gsum/totalsum*100).toFixed(1)+"%)"}}</td>
                <td class="text-center">{{ age10sum+" ("+(age10sum/totalsum*100).toFixed(1)+"%)"}}</td>
                <td class="text-center">{{ age20sum+" ("+(age20sum/totalsum*100).toFixed(1)+"%)"}}</td>
                <td class="text-center">{{ age30sum+" ("+(age30sum/totalsum*100).toFixed(1)+"%)"}}</td>
                <td class="text-center">{{ age40sum+" ("+(age40sum/totalsum*100).toFixed(1)+"%)"}}</td>
                <td class="text-center">{{ age50sum+" ("+(age50sum/totalsum*100).toFixed(1)+"%)"}}</td>
                <td class="text-center">{{ age60sum+" ("+(age60sum/totalsum*100).toFixed(1)+"%)"}}</td>
                <td class="text-center">{{ age70sum+" ("+(age70sum/totalsum*100).toFixed(1)+"%)"}}</td>
                <td class="text-center">{{ age80sum+" ("+(age80sum/totalsum*100).toFixed(1)+"%)"}}</td>
              </tr>
              <tr v-for="item in list" :key="item.REG_DATE">
                <td class="text-center">{{ item.REG_DATE }}</td>
                <td class="text-center">{{ item.DAYSUM }}</td>
                <td class="text-center">{{ item.MAN }}</td>
                <td class="text-center">{{ item.GIRL }}</td>
                <td class="text-center">{{ item.AGE10 }}</td>
                <td class="text-center">{{ item.AGE20 }}</td>
                <td class="text-center">{{ item.AGE30 }}</td>
                <td class="text-center">{{ item.AGE40 }}</td>
                <td class="text-center">{{ item.AGE50 }}</td>
                <td class="text-center">{{ item.AGE60 }}</td>
                <td class="text-center">{{ item.AGE70 }}</td>
                <td class="text-center">{{ item.AGE80 }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>

  </v-container>
</template>
<script>

//eslint-disable-next-line no-unused-vars
import Chart from 'chart.js/auto';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import moment from 'moment'
import XLSX from 'xlsx'
export default {

  mounted(){

    if(this.$session.get("GRADE") < 10){
      this.$alert(this.$t("common_nograde"));
      this.$router.push("Login");
      return;
    }

    this.SEARCH_COM_IDX    = this.$session.get("COM_IDX");
    this.SEARCH_COM_NAME   = this.$session.get("COM_NAME");
    this.SEARCH_EVENT_IDX  = this.$session.get("EVENT_IDX");
    this.SEARCH_EVENT_NAME = this.$session.get("EVENT_NAME");
    this.grade = this.$session.get("GRADE");

    this.search_start_date  = this.$session.get("EVENT_START");
    if(this.search_start_date == null || this.search_start_date == undefined){
      this.search_start_date = moment().subtract(1, 'YEARS').format("YYYY-MM-DD");
    }
    this.search_end_date    = this.$session.get("EVENT_END");
    if(this.search_end_date == null || this.search_end_date == undefined){
      this.search_end_date   = moment().format("YYYY-MM-DD");
    }


    //Chart.register(ChartDataLabels);

    if(this.$session.exists("ADMIN_IDX")){
      this.initpage();
    }else{
      //키값 없으면 로그인으로
      this.$router.push("Login");
    }
  },


  
  beforeDestroy(){

    //차트 초기화 - 제대로 안지우면 인스턴스 계속 쌓인다.
    if(this.myChart1 != null){
      this.myChart1.destroy();
    }
    if(this.myChart2 != null){
      this.myChart2.destroy();
    }

  },


  data: () => ({

      myChart1: null,
      myChart2: null,

      date1:false,
      date2:false,
      search_start_date : '',
      search_end_date : '',
      checkdate : true,
      list:[],
      totalsum:0,
      msum:0,
      gsum:0,
      age10sum:0,
      age20sum:0,
      age30sum:0,
      age40sum:0,
      age50sum:0,
      age60sum:0,
      age70sum:0,
      age80sum:0,
      SEARCH_COM_IDX: null,
      SEARCH_COM_NAME: '',
      SEARCH_EVENT_IDX: null,
      SEARCH_EVENT_NAME: '',
      grade : 0,

  }),

  methods: {

    startDownload(){

      this.$confirm(this.$t('common_downexcel2')).then(() => {

        var templist = [];
        this.list.forEach(item=>{
          templist.push({
            "REG_DATE":item.REG_DATE
          , "DAYSUM":parseInt(item.DAYSUM)
          , "MAN":parseInt(item.MAN)
          , "GIRL":parseInt(item.GIRL)
          , "AGE10":parseInt(item.AGE10)
          , "AGE20":parseInt(item.AGE20)
          , "AGE30":parseInt(item.AGE30)
          , "AGE40":parseInt(item.AGE40)
          , "AGE50":parseInt(item.AGE50)
          , "AGE60":parseInt(item.AGE60)
          , "AGE70":parseInt(item.AGE70)
          , "AGE80":parseInt(item.AGE80)
          });
        });

        //하단 합계 넣기
        templist.push({
            "REG_DATE":this.$t("chartuserinfo_label2")
          , "DAYSUM":parseInt(this.totalsum)
          , "MAN":parseInt(this.msum)
          , "GIRL":parseInt(this.gsum)
          , "AGE10":parseInt(this.age10sum)
          , "AGE20":parseInt(this.age20sum)
          , "AGE30":parseInt(this.age30sum)
          , "AGE40":parseInt(this.age40sum)
          , "AGE50":parseInt(this.age50sum)
          , "AGE60":parseInt(this.age60sum)
          , "AGE70":parseInt(this.age70sum)
          , "AGE80":parseInt(this.age80sum)
        });
        
        var item_sheet = XLSX.utils.json_to_sheet(templist);

        //상단 컬럼명 수정
        item_sheet.A1 = {v:this.$t("chartuserinfo_col12")};
        item_sheet.B1 = {v:this.$t("chartuserinfo_col1")};
        item_sheet.C1 = {v:this.$t("chartuserinfo_col2")};
        item_sheet.D1 = {v:this.$t("chartuserinfo_col3")};
        item_sheet.E1 = {v:this.$t("chartuserinfo_col4")};
        item_sheet.F1 = {v:this.$t("chartuserinfo_col5")};
        item_sheet.G1 = {v:this.$t("chartuserinfo_col6")};
        item_sheet.H1 = {v:this.$t("chartuserinfo_col7")};
        item_sheet.I1 = {v:this.$t("chartuserinfo_col8")};
        item_sheet.J1 = {v:this.$t("chartuserinfo_col9")};
        item_sheet.K1 = {v:this.$t("chartuserinfo_col10")};
        item_sheet.L1 = {v:this.$t("chartuserinfo_col11")};

        //컬럼별 너비
        var wscols = [{wch:20},{wch:10},{wch:10},{wch:10},{wch:10,},{wch:10},{wch:10},{wch:10},{wch:10},{wch:10},{wch:10},{wch:10}];
        item_sheet['!cols'] = wscols;

        var wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, item_sheet, this.$t("chartuserinfo_label3"));
        XLSX.writeFile(wb, this.$t("chartuserinfo_label4")+moment().format('YYYYMMDDHHmmss')+'.xlsx');

      });

    },    

    initpage(){
      this.search_run();
    },

    dynamicColors : function() {
        var r = Math.floor(Math.random() * 255);
        var g = Math.floor(Math.random() * 255);
        var b = Math.floor(Math.random() * 255);
        return "rgba(" + r + "," + g + "," + b + ",1)";
    },

    search_run(){

      if(this.grade < 99){
        if(this.SEARCH_EVENT_IDX == null){
          this.$alert(this.$t('common_select_tevent'));
          return;
        }
      }

      if(this.search_start_date.length < 4){
        this.$alert(this.$t('common_search_start_info1'));
        return;
      }
      if(this.search_end_date.length < 4){
        this.$alert(this.$t('common_search_end_info1'));
        return;
      }
      if(this.search_start_date > this.search_end_date){
        this.$alert(this.$t('common_search_date_error1'));
        return;
      }


      this.$http.post(this.$host+'/api/ChartUserInfo',{
            ADMIN_IDX: this.$session.get("ADMIN_IDX")
          , COM_IDX:   this.SEARCH_COM_IDX == undefined ? '' : this.SEARCH_COM_IDX
          , EVENT_IDX: this.SEARCH_EVENT_IDX == undefined ? '' : this.SEARCH_EVENT_IDX
          , CHECKDATE: this.checkdate
          , search_start_date:this.search_start_date == undefined ? '' : this.search_start_date
          , search_end_date:this.search_end_date == undefined ? '' : this.search_end_date
          , LAN_CODE:this.$i18n.locale
      },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
      .then((result)=>{

        this.loading = false;
        
        if(result.data.resultCode == 0){

            //토큰 저장
            if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
              this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
            }
            if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
              this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
            }

            const ctx1 = this.$refs.drawarea1;
            const ctx2 = this.$refs.drawarea2;
            //차트 초기화 - 제대로 안지우면 인스턴스 계속 쌓인다.
            if(this.myChart1 != null){
              this.myChart1.destroy();
            }
            if(this.myChart2 != null){
              this.myChart2.destroy();
            }

            var mansum = 0;
            var girlsum = 0;
            this.msum = 0;
            this.gsum = 0;
            this.totalsum = 0;
            this.age10sum = 0;
            this.age20sum = 0;
            this.age30sum = 0;
            this.age40sum = 0;
            this.age50sum = 0;
            this.age60sum = 0;
            this.age70sum = 0;
            this.age80sum = 0;
            
            this.list.splice(0, this.list.length);   //데이터 초기화
            this.list = result.data.resultData;
            const man_data = [];
            const girl_data = [];
            const age10_data = [];
            const age20_data = [];
            const age30_data = [];
            const age40_data = [];
            const age50_data = [];
            const age60_data = [];
            const age70_data = [];
            const age80_data = [];
            const datanames = [];
            this.list.forEach(item=>{
               
               mansum  += parseInt(item.MAN);
               girlsum += parseInt(item.GIRL);
               this.msum += parseInt(item.MAN);
               this.gsum += parseInt(item.GIRL);

               item.DAYSUM = parseInt(item.MAN) + parseInt(item.GIRL);
               this.totalsum += item.DAYSUM;

               this.age10sum += parseInt(item.AGE10);
               this.age20sum += parseInt(item.AGE20);
               this.age30sum += parseInt(item.AGE30);
               this.age40sum += parseInt(item.AGE40);
               this.age50sum += parseInt(item.AGE50);
               this.age60sum += parseInt(item.AGE60);
               this.age70sum += parseInt(item.AGE70);
               this.age80sum += parseInt(item.AGE80);

               man_data.push(item.MAN);
               girl_data.push(item.GIRL);
               age10_data.push(item.AGE10);
               age20_data.push(item.AGE20);
               age30_data.push(item.AGE30);
               age40_data.push(item.AGE40);
               age50_data.push(item.AGE50);
               age60_data.push(item.AGE60);
               age70_data.push(item.AGE70);
               age80_data.push(item.AGE80);
               datanames.push(item.REG_DATE);
            });
            
            var ageTotal = this.age10sum+this.age20sum+this.age30sum+this.age40sum+this.age50sum+this.age60sum+this.age70sum+this.age80sum;

            /*
            if(this.checkdate){

              //일자별 그래프
              const datas3 = {
                labels:datanames, //차트 하단에 표시됨
                datasets:[
                    {label:'남성', data:man_data,  backgroundColor: 'rgb(0, 0, 128)', borderColor: 'rgb(0, 0, 128)', lineTension:0.3, fill: false,}
                  , {label:'여성', data:girl_data, backgroundColor: 'rgb(255, 67, 107)',borderColor: 'rgb(255, 67, 107)', lineTension:0.3, fill: false,}
                  , {label:'10대', data:age10_data, backgroundColor: 'rgb(93, 142, 193)',borderColor: 'rgb(93, 142, 193)', lineTension:0.3, fill: false,}
                  , {label:'20대', data:age20_data, backgroundColor: 'rgb(240, 168, 76)',borderColor: 'rgb(240, 168, 76)', lineTension:0.3, fill: false,}
                  , {label:'30대', data:age30_data, backgroundColor: 'rgb(9, 156, 253)',borderColor: 'rgb(9, 156, 253)', lineTension:0.3, fill: false,}
                  , {label:'40대', data:age40_data, backgroundColor: 'rgb(14, 52, 91)',borderColor: 'rgb(14, 52, 91)', lineTension:0.3, fill: false,}
                  , {label:'50대', data:age50_data, backgroundColor: 'rgb(16, 151, 208)',borderColor: 'rgb(16, 151, 208)', lineTension:0.3, fill: false,}
                  , {label:'60대', data:age60_data, backgroundColor: 'rgb(67, 164, 157)',borderColor: 'rgb(67, 164, 157)', lineTension:0.3, fill: false,}
                  , {label:'70대', data:age70_data, backgroundColor: 'rgb(124, 252, 0)',borderColor: 'rgb(124, 252, 0)', lineTension:0.3, fill: false,}
                  , {label:'80대', data:age80_data, backgroundColor: 'rgb(255, 215, 0)',borderColor: 'rgb(255, 215, 0)', lineTension:0.3, fill: false,}
                ],
              };

                const options3 = {
                  title: {
                      display: true,
                      text: '참가자 일자별 현황'
                  },              
                  tooltips: {
                      mode: 'index',
                      intersect: false,
                  },
                  legend: { 
                      position: 'right' 
                  },
                  hover: {
                      mode: 'nearest',
                      intersect: true
                  },
                  scales: {
                      xAxes: [{
                          display: true,
                          ticks:{reverse:true},
                          scaleLabel: {
                              display: true,
                              labelString: '날짜'
                          }
                      }],
                      yAxes: [{
                          display: true,
                          ticks: {
                              beginAtZero:true,
                              suggestedMin: 0,
                          },
                          scaleLabel: {
                              display: true,
                              labelString: '참가자'
                          }
                      }]
                  },    
                  responsive: true,
                  maintainAspectRatio: false,
                  aspectRatio : 2
                };     
              var tempdiv3 = document.createElement("div");
              tempdiv3.className = "chart-container";
              tempdiv3.style.marginBottom = 50+"px";
              
              var tempcanvas3 = document.createElement("canvas");
              tempcanvas3.style.height = "70vh";
              tempcanvas3.style.width = "50vw";
              tempdiv3.appendChild(tempcanvas3);
              parent.appendChild(tempdiv3);

              //eslint-disable-next-line no-unused-vars
              var temp_chart3 = new Chart(tempcanvas3, {type:'line', data:datas3, options: options3});
              this.myChart2.set("days", temp_chart3);
              temp_chart3.update();

            }
            */

            const datas = {
              labels:[this.$t("chartuserinfo_label5"),this.$t("chartuserinfo_label6")],
              datasets:[
                  { data:[mansum, girlsum], backgroundColor: ['#7b6dd0', '#6c9ae7'], borderColor: ['#7b6dd0', '#6c9ae7']}
              ],
            };

            
            const options = {
              plugins: {
                datalabels: {
                  color: '#ffffff',
                  backgroundColor: '#00000080',
                  //차트 기본 표시정보 재정의
                  formatter:function(value){
                    var rdata = parseInt(value)/(mansum + girlsum)*100;
                    return value + this.$t("chartuserinfo_label7")+" ("+ rdata.toFixed(1)+"%)";
                  }.bind(this),//위의 this가 뷰를 가르키지 않아서 arrow function을 사용하여 this를 캡처합니다.
                  //0값은 표시 안함
                  display: function(context) {
                      return context.dataset.data[context.dataIndex] !== 0; // or >= 1 or ...
                  }
                },
                legend: { 
                    position: 'right' 
                },
                title: {
                    display: true,
                    text: this.$t("chartuserinfo_label8")
                },         
                tooltip: {
                    callbacks:{
                      label:function(context){ 
                        var value1 = context.formattedValue;
                        var rdata = parseInt(value1)/(mansum + girlsum)*100;
                        return context.label +" " + value1 + this.$t("chartuserinfo_label7")+" ("+ rdata.toFixed(1)+"%)";
                      }.bind(this)
                    }
                },
              },
              scales: {
                  xAxes: [{
                      display: false,
                  }],
                  yAxes: [{
                      display: false,
                  }]
              },    
              responsive: true,
              maintainAspectRatio: true,
              aspectRatio : 2.5
            };     
            this.myChart1 = new Chart(ctx1, {type:'pie', data:datas, options: options, plugins:[ChartDataLabels]});

            //연령 파이차트
            const datas2 = {
              labels:[this.$t("chartuserinfo_col4"),this.$t("chartuserinfo_col5"),this.$t("chartuserinfo_col6"),this.$t("chartuserinfo_col7"),this.$t("chartuserinfo_col8"),this.$t("chartuserinfo_col9"),this.$t("chartuserinfo_col10"),this.$t("chartuserinfo_col11")],
              datasets:[
                  { 
                    data:[this.age10sum,this.age20sum,this.age30sum,this.age40sum,this.age50sum,this.age60sum,this.age70sum,this.age80sum]
                  , backgroundColor: ['#74a6f8','#74a6f8','#74a6f8','#74a6f8','#74a6f8','#74a6f8','#74a6f8','#74a6f8']
                  , borderColor: ['#74a6f8','#74a6f8','#74a6f8','#74a6f8','#74a6f8','#74a6f8','#74a6f8','#74a6f8']
                  }
              ],
            };
            const options2 = {
              plugins: {
                title: {
                    display: true,
                    text: this.$t("chartuserinfo_label9")
                },         
                legend: { 
                  display:false
                },
                tooltip: {
                    callbacks:{
                      label:function(context){ 
                        var value1 = context.formattedValue;
                        var rdata = parseInt(value1)/(ageTotal)*100;
                        return context.label +" " + value1 + this.$t("chartuserinfo_label7")+" ("+ rdata.toFixed(1)+"%)";
                      }.bind(this)
                    }
                },
              },
              scales: {
                  y:{
                      beginAtzero:false
                    , stacked: false
                  },
                  x: {
                    stacked: false
                  },                  
                  xAxes: [{
                      display: false,
                  }],
                  yAxes: [{
                      display: false,
                  }],
              },    
              responsive: true,
              maintainAspectRatio: true,
              aspectRatio : 2.5
            };     
            this.myChart2 = new Chart(ctx2, {type:'bar', data:datas2, options: options2});
            

        }else if(result.data.resultCode == 2){
          //로그인 필요
          this.$alert(this.$t("common_tokener"));
          this.$session.clear("ADMIN_IDX");
          this.$session.clear("COM_IDX");
          this.$session.clear("ACNT_IDX");
          this.$session.clear("GRADE");
          this.$session.clear("COM_NAME");
          this.$session.clear("ACCESSTOKEN");
          this.$session.clear("REFLASHTOKEN");
          this.$router.push('Login');   //로그인 페이지로 이동

        }
      })
      // eslint-disable-next-line no-unused-vars
      .catch((error)=>{
        this.loading = false;
        if(error.message == 'Request failed with status code 429')
        {
          this.$alert(this.$t("common_reqer"));
        }else{
          this.$alert(error.message);
        }
      });

    },

    priceToString(price) {
      return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },

    //검색조건 업체 설정
    eventsearchcb(val1){
      if(val1.NAME.length > 0){
        this.SEARCH_EVENT_NAME = val1.NAME;
        this.SEARCH_EVENT_IDX  = val1.IDX;
        this.$session.set("EVENT_IDX", val1.IDX);
        this.$session.set("EVENT_NAME",val1.NAME);

        this.search_start_date = moment(val1.EVENT_START, "YYYY-MM-DD").format("YYYY-MM-DD");
        this.search_end_date  = moment(val1.EVENT_END, "YYYY-MM-DD").format("YYYY-MM-DD");
        this.$session.set("EVENT_START", this.search_start_date);
        this.$session.set("EVENT_END", this.search_end_date);

      }else{
        this.SEARCH_EVENT_IDX = null;
        this.SEARCH_EVENT_NAME = "";
        this.$session.set("EVENT_IDX", null);
        this.$session.set("EVENT_NAME", "");
        this.$session.set("EVENT_START", null);
        this.$session.set("EVENT_END", null);

      }
      this.search_run();
    },

    // eslint-disable-next-line no-unused-vars
    comsearchclear(var2){
        this.SEARCH_COM_IDX    = null;
        this.SEARCH_COM_NAME   = '';
        this.SEARCH_EVENT_IDX  = null;
        this.SEARCH_EVENT_NAME = '';
        this.$session.set("COM_IDX",  null);
        this.$session.set("COM_NAME", "");
        this.$session.set("EVENT_IDX", null);
        this.$session.set("EVENT_NAME", "");
        this.search_run();
    },

    //업체선택 콜백
    comdialogcb(val){
      if(val.NAME.length > 0){
        this.editedItem.COM_NAME = val.NAME;
        this.editedItem.COM_IDX  = val.IDX;
      }else{
        this.$alert(this.$t('common_select_company'));
        return;
      }
    },

    //검색조건 업체 설정
    comsearchcb(val1){
      if(val1.NAME.length > 0){
        this.SEARCH_COM_NAME = val1.NAME;
        this.SEARCH_COM_IDX  = val1.IDX;
        this.$session.set("COM_IDX", val1.IDX);
        this.$session.set("COM_NAME", val1.NAME);
        this.SEARCH_EVENT_IDX = null;
        this.SEARCH_EVENT_NAME = '';
        this.$session.set("EVENT_IDX", null);
        this.$session.set("EVENT_NAME", "");
      }else{
        this.SEARCH_COM_NAME = '';
        this.SEARCH_COM_IDX  = null;
        this.SEARCH_EVENT_IDX = null;
        this.SEARCH_EVENT_NAME = '';
        this.$session.set("COM_IDX",  null);
        this.$session.set("COM_NAME", "");
        this.$session.set("EVENT_IDX", null);
        this.$session.set("EVENT_NAME", "");
      }
      this.search_run();
    },



  }
    
}

</script>

<!-- scoped가 있으면 해당 컴포넌트에서만 스타일이 반영됨 -->
<style scoped>

    .chart-container {
			width: 600px;
			margin-left: 10px;
			margin-right: 10px;
			margin-bottom: 50px;
			border: 1px solid black;
		}

</style>